import { INIT_GAME } from '../actions/initGame.actions'
import MANIFEST from '../../constants/MANIFEST'

const initialState = {
    status: false,
    version: -1,
}

const initGameReducer = (state = initialState, action) => {
    switch (action.type) {
        case INIT_GAME: {
            return {
                status: true,
                version: MANIFEST.version,
            }
        }

        default: {
            return state
        }
    }
}

export default initGameReducer
